import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';

@Component({
  selector: 'app-ship-location-page',
  templateUrl: './ship-location-page.component.html',
  styleUrls: ['./ship-location-page.component.css'],
})
export class ShiplocationPageComponent implements OnInit, OnDestroy {
  userdata?: UserData;
  LoginData: any;
  employeeData?: EmployeeData;
  shpId: number | undefined;

  validsession: boolean | undefined;
  dplDeck: string | undefined;
  sdplDeck: string | undefined;

  private paramsSub?: Subscription;

  constructor(
    private sesssionvalidator: SessionvalidateService,
    private router: Router,
    private route: ActivatedRoute,
    private EmployeeLoginService: EmployeeloginService
  ) {}

  ngOnInit(): void {
    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo != undefined) {
      this.checkLogin();
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.subscribeToParams();
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/login']);
      }
    }
  }

  ngOnDestroy(): void {
    this.paramsSub?.unsubscribe();
  }

  private subscribeToParams(): void {
    this.paramsSub = this.route.params.subscribe((params) => {
      this.dplDeck = params['dplDeck'];
      this.sdplDeck = this.dplDeck;
    });
  }

  checkLogin() {
    this.LoginData = this.EmployeeLoginService.GetEmployeeLogin(
      this.employeeData?.EmployeeNo,
      this.employeeData?.LastName
    ).subscribe((LoginData) => this.setCheckLogin(LoginData));
  }

  setCheckLogin(resdata: any) {
    this.LoginData = resdata;
    if (this.LoginData.GetEmployeeLogin.Result.Status != 'A') {
      this.router.navigate(['/adminlogin']);
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.subscribeToParams();
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/shipselect']);
      }
    }
  }
}
